import React from 'react';
import './App.css';
import successlogo from "./resources/successlogo.png";

function PaymentSuccess() {

    const handleButtonClick = () => {
        window.location.reload();
    };

    return (
        <div style={{position: "fixed", top: "40%", left: "50%", transform: "translate(-50%, -50%)"}}>
            <img src={successlogo}
                 alt="successlogo"/>
            Etcbase Abonelik Ödeme İşlemi Başarılı
            <button style={{
                display: "block",
                margin: "20px auto",
                width: "200px",
                padding: "10px",
                fontSize: "16px"
            }} onClick={handleButtonClick}>Tamam</button>
        </div>
    )
}

export default PaymentSuccess;